; (function () {
  const apiToken = initialToken => {
    return {
      token: initialToken || '',

      generate: function () {
        const bytes = new Uint8Array(32)

        window.crypto.getRandomValues(bytes)

        this.token = Array.from(bytes, byte =>
          byte.toString(16).padStart(2, '0')
        ).join('')
      }
    }
  }

  if (typeof window !== 'undefined') {
    window.apiToken = apiToken
  }
  return apiToken
})()
